"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Change Shopify theme
window.changeTheme = function (themeId) {
  var kvp = document.location.search.substr(1).split('&');
  [['_ab', '0'], ['_fd', '0'], ['_sc', '1'], ['preview_theme_id', themeId]].forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var i = 0;
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    for (i; i < kvp.length; i++) {
      if (kvp[i].startsWith(key + '=')) {
        var pair = kvp[i].split('=');
        pair[1] = value;
        kvp[i] = pair.join('=');
        break;
      }
    }

    if (i >= kvp.length) {
      kvp[kvp.length] = [key, value].join('=');
    }
  }); // reload page with new params

  document.location.search = kvp.join('&');
}; // Go back to live theme


window.live = function () {
  // find iframe
  var iframe = $('#preview-bar-iframe'); // find button inside iframe

  var button = iframe.contents().find('button[data-exit-preview-button]'); // trigger button click

  button.trigger("click");
}; // Have forEach on HTMLCollections.


window.HTMLCollection.prototype.forEach = function (callback) {
  for (var i = 0; i < this.length; i++) {
    callback(this[i], i);
  }
};

document.addEventListener('DOMContentLoaded', function () {
  // if (
  //     window.Shopify.theme.id !== 80633888865 &&
  //     null !== window.location.href.match(/\/pages\//gm)
  // ) {
  //     document.getElementsByTagName('html')[0].style.opacity = '0.3';
  //     window.changeTheme(80633888865);
  // }
  // iOS-specific css fixes
  // if (/ipad|iphone/.test(window.navigator.userAgent.toLowerCase())) {
  //     document.getElementsByClassName('theme-ajax-cart').forEach(miniCart => miniCart.classList.add('ios-device'));
  // }
  // Add random numbers to known-offender duplicate elements.
  window.devMode = !!document.getElementById('preview-bar-iframe');
  document.querySelectorAll('.currencies-dropdown, .shopify-currency-form').forEach(function (element) {
    return element.id = element.id + ' ' + Math.random();
  });
  window.defer(function () {
    $(document).on('click', '[id^=checkout]', function (e) {
      var geolocationContainer = $('.recommendation-modal__container'),
          geolocationOverlay = $('.recommendation-modal__backdrop');

      if (!window.currencyChecked && geolocationContainer.length > 0) {
        e.preventDefault();
        geolocationContainer.css('display', 'block');
        geolocationOverlay.css('display', 'block');
        window.currencyChecked = true;
      }
    });
  });
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Show the loading circle and disable checkout buttons.
window.loadingCircle = function () {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  document.getElementsByClassName("loading-for--".concat(key)).forEach(function (circle) {
    return circle.style.display = hide ? 'none' : 'inline-flex';
  });
  [].concat(_toConsumableArray(document.getElementsByClassName('ajax-cart__button')), _toConsumableArray(document.getElementsByClassName('add_to_cart'))).forEach(function (e) {
    return !hide ? e.setAttribute('disabled', true) : e.removeAttribute('disabled');
  });
};

window.updateWrappingSelects = function () {
  return Shopify.theme.ajaxCart.getState().then(function (cart) {
    // For each proper cart item, check if it's a giftwrap and match it to its linked line item.
    // Change the relevant html and ensure we have the right quantity of giftwrap.
    cart.items.filter(function (item) {
      return !item.properties || item.properties && !item.properties.lineItemKey;
    }).forEach(function (item, i) {
      var giftWrapItem = cart.items.reduce(function (finalItem, giftWrapItem) {
        return giftWrapItem.properties && giftWrapItem.properties.lineItemKey === item.key ? giftWrapItem : finalItem;
      }, null),
          giftWrapPrice = null !== giftWrapItem ? "<span class=\"money\">".concat(Shopify.formatMoney(giftWrapItem.final_line_price, $('body').data('money-format')), "</span>") : '',
          giftWrapPriceHTML = document.getElementsByClassName("giftwrap-price-for--".concat(item.key)),
          updateGiftWrapPrice = function updateGiftWrapPrice() {
        return giftWrapPriceHTML.forEach(function (priceElement) {
          return priceElement.innerHTML = giftWrapPrice;
        });
      }; // Set the line item's selects to the right value.


      document.getElementsByClassName("select-for--".concat(item.key)).forEach(function (select) {
        return select.value = null === giftWrapItem ? '' : giftWrapItem.variant_id;
      }); // Ensure giftwrap quantity is the same as the cart item quantity and update the view.

      if (null !== giftWrapItem && giftWrapItem.quantity !== item.quantity) {
        // Show the loading circle and remove the giftwrap price.
        loadingCircle(item.key);
        giftWrapPriceHTML.forEach(function (price) {
          return price.innerHTML = '';
        });
        fetch('/cart/change.js', {
          method: 'POST',
          body: JSON.stringify({
            id: giftWrapItem.key,
            quantity: item.quantity
          }),
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (res) {
          return res.json();
        }).then(function (cart) {
          if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          } else if (Shopify.theme.jsCart) {
            Shopify.theme.jsCart.updateView(cart, i + 1);
          }

          updateGiftWrapPrice();
          loadingCircle(item.key, 'hide');
        });
      } else {
        updateGiftWrapPrice();
        loadingCircle(item.key, 'hide');
      }
    }); // Make a check to ensure all accessories have an item associated with them.
    // Remove the wrap if it has no associated item.

    cart.items.filter(function (item) {
      return item.properties && item.properties.lineItemKey;
    }).forEach(function (accessory) {
      var associatedLineItem = cart.items.reduce(function (finalItem, lineItem) {
        return lineItem.key === accessory.properties.lineItemKey ? lineItem : finalItem;
      }, null);
      if (null === associatedLineItem) changeWrap({
        target: {
          value: ''
        }
      }, {
        key: accessory.properties.lineItemKey,
        sku: accessory.properties.sku
      });
    });
  });
};

window.addGiftWrap = function (e, item) {
  return Shopify.theme.ajaxCart.addItem(parseInt(e.target.value), {
    quantity: item.quantity,
    properties: {
      'Giftwrap for': item.title,
      'lineItemKey': item.key,
      'lineItemId': item.id,
      'sku': item.sku
    }
  }).then(function () {
    return Shopify.theme.ajaxCart.getState();
  }).then(function (cart) {
    if (Shopify.theme.jsCart) Shopify.theme.jsCart.updateView(cart, 1);
    Shopify.theme.jsAjaxCart.updateView();
  });
};

window.changeWrap = function (e, item) {
  var noChange = true; // Show the loading circle and remove giftwrap price.

  loadingCircle(item.key);
  document.getElementsByClassName("giftwrap-price-for--".concat(item.key)).forEach(function (price) {
    return price.innerHTML = '';
  }); // The first query works for desktop. The second query works for mobile... Idk man, idk.

  var queryDesktop = '#theme-ajax-cart.desktop-cart .ajax-cart__list .ajax-cart__product',
      queryMobile = '#theme-ajax-cart.mobile-cart form > div.ajax-cart__list .ajax-cart__product'; // If the wrapping option has changed, check to see if we need to remove wrapping from the order.

  var lineItems = document.querySelectorAll(queryDesktop).length > 0 ? document.querySelectorAll(queryDesktop) : document.querySelectorAll(queryMobile);
  lineItems.forEach(function (lineItem, index) {
    var text = lineItem.innerHTML;

    if ((text.includes('crapwrap') || text.includes('golden-gift-wrap')) && text.includes('sku: ' + item.sku) && text.includes(item.key)) {
      noChange = false;
      var jsCart = typeof Shopify.theme.jsAjaxCart !== 'undefined' ? Shopify.theme.jsAjaxCart : Shopify.theme.jsCart;
      jsCart.removeFromCart(index + 1).then(function () {
        // Now we've removed the old giftwrap, add the new one or if we're selecting nothing, remove the loading circle.
        if ('' !== e.target.value) {
          addGiftWrap(e, item);
        } else {
          // Make sure to update the cart even if we aren't adding a new giftwrap.
          Shopify.theme.ajaxCart.getState().then(function (cart) {
            if (Shopify.theme.jsCart) Shopify.theme.jsCart.updateView(cart, index + 1);
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') Shopify.theme.jsAjaxCart.updateView();
          });
        }
      }).catch(function (err) {
        console.log(err);
        loadingCircle(item.key, 'hide');
      });
    }
  }); // If there was no giftwrap to get rid of, just add the new giftwrap or if we're selecting nothing, remove the loading circle.

  if ('' !== e.target.value && noChange) {
    addGiftWrap(e, item);
  } else if (noChange) {
    loadingCircle(item.key, 'hide');
  }
};

window.toggleWrapInfo = function () {
  document.getElementsByClassName('crap-wrap_img')[0].src = 'https://cdn.shopify.com/s/files/1/0099/2460/8097/products/crapwrap_500x.jpg';
  document.getElementsByClassName('golden-wrap_img')[0].src = 'https://cdn.shopify.com/s/files/1/0099/2460/8097/products/goldenboy_500x.jpg';
  document.getElementsByClassName('gift-wrap-overlay')[0].classList.toggle('is-hidden');
  document.getElementsByClassName('gift-wrap-overlay')[0].style.display = 'block';
}; // Sort out all the giftwrapping things.


document.addEventListener('DOMContentLoaded', function () {
  return setTimeout(function () {
    return updateWrappingSelects();
  }, 1000);
});
"use strict";

// This makes sure newsletter signups work well.
window.defer(function () {
  return $('#out_of_stock_newsletter_form, #newsletter_form').submit(function (event) {
    event.preventDefault();
    this.submit();
  });
});
"use strict";

// This is code Marcus wrote to do things with the search popup.
window.defer(function () {
  $(document).on('keydown', '.search-popup .control > .input', function () {
    var results = $('.snize-ac-results');
    var insertBefore = $('.search-menu__title');

    if (results.length > 0 && 0 === $('.search-result').length) {
      insertBefore.before('<div class="one-whole search-result"></div>');
      $('.one-whole.search-result').append(results);
    }
  });
});